/*
MODIFICATION IS PROVIDED BY SEARCHANISE TEAM. WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

The modification allows showing custom content in the Instant search widget before the user types search query. 

For the modification to work, make sure the "Show popular suggestions on click" option is enabled in your app admin panel > Search & Navigation > Instant search widget > Content tab. 

You can specify what content will be displayed for Products, Categories and Pages sections.

If you need to disable the modification, find the variable isEnabled in the Settings section and change its value to false, so it looks like that:

let isEnabled = false;

PRODUCTS

The list of the products depends on the tag specified in the productTag variable. 
You can change what products are displayed in the widget by adding/removing the corresponding tag from the products information in your admin panel. 
You can also change the tag the modification uses. Please make sure the tag is enclosed in quote marks. 

Here is an example of how it should look like: 

let productTag = "featured-search";

COLLECTIONS

Collections that will be displayed are controlled by the fixedCollectionsList variable.
The variable contains the list of the pairs, each pair specifies the collection name and its link. 
There are a few important formatting rules to follow: 

1. Make sure that your collections names and links are enclosed in quote marks. 
2. Collection name and collection link should be devided by a column. 
3. Each pair should be closed by a comma. 

Here is an example of the correct fomatting: 

let fixedCollectionsList = { 
    "Collection 1": "/collections/collection1",
    "Collection 2": "/collections/collection2",
}

PAGES

Information about the pages that will be displayed is specified in the fixedPagesList variable. 
The structure of the variable is similar to the one of the collections and follows the same rules. 
The variable includes the list of the pair, each pair specifies the name of the page and its link. 

Here is an example of the correctly populated fixedPagesList variable: 

let fixedPagesList = {
    "Page 1": "https://taosfootwear.com/pages/page1",
    "Page 2": "https://taosfootwear.com/pages/page2",
}

*/
document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        // Settings start

        let fixedCollectionsList = { 
            // "collection name": "collection link",
            "Tulips": "/collections/tulips",
            "Peonies": "/collections/peonies",
            "Fall-Planted Bulbs": "/collections/spring_bulbs",
            "Irises": "/collections/Iris",
            "Lily Bulbs": "/collections/lilies-summer-bulbs",
            "Hibiscus": "/collections/hibiscus",
        }
        
        let fixedPagesList = {
            // "page name" : "page link",
            "page 1": "page 1 link",
            "page 2": "page 2 link",
        }
        
        let fixedSuggestionsList = ["suggestion one", "suggestion two"];
        
        let isEnabled = true;

        let productTag = "featured-search";

        let fixedProductsSearchRequest = `https://searchserverapi1.com/getresults?api_key=3g4Z3f3i6h&sortBy=title&sortOrder=desc&items=true&facets=false${productTag ? `&restrictBy[tags]=${productTag}` : ''}`;

        // Settings end

        if (!isEnabled || isEnabled === 'false') { return }

        let fixedProductsList = [];

        let autcompleteSectionsOrder = Searchanise.GetWidgets().options.AutocompleteResultsOrder;

        async function showFixedProducts(container, input) {
            
            if (!fixedProductsList.length) {
                $('.snize-ac-results-content:not(.hidden)').addClass('hidden');
                await $.get(fixedProductsSearchRequest, function(data) {
                    fixedProductsList = JSON.parse(data).items;
                });
            }
            
            $('.snize-ac-results-content.hidden').removeClass('hidden');

            if (!input.prop('value')) {
                $('.snize-no-products-found').remove();
                if (!$('#snize-ac-items-container-4 .snize-label', container).length) {
                    $('#snize-ac-items-container-4', container).prepend(`<li class="snize-label">TRENDING PRODUCTS</li>`);
                }
                fixedProductsList.forEach((item) => {
                    if ($('.snize-product', container).length == Searchanise.GetWidgets().options.AutocompleteItemCount) {
                        return;
                    }
                    if (window.innerWidth > 1024) {
                        $('#snize-ac-items-container-4', container).append(
                        `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href=${item.link} class="snize-item" draggable="false"><div class="snize-thumbnail"><img src=${item.image_link} class="snize-item-image " alt="${item.title}"></div><span class="snize-title">${item.title}</span><span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-price-list"><span class="snize-price snize-price-with-discount money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></a></li>`);
                    } else {
                        $('#snize-ac-items-container-4', container).append(
                        `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href="${item.link}" class="snize-item"><div class="snize-thumbnail"><img src="${item.image_link}" class="snize-item-image " alt="${item.title}"></div><div class="snize-product-info"><span class="snize-title">${item.title}</span><span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-ac-prices-container"><div class="snize-price-list"><span class="snize-price snize-price-with-discount money theme-money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></div></div></a></li>`);
                    }
                });
                $('.snize-ac-results-columns', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-4', container).removeClass('snize-hidden');
            } 
        }

        // valid section options: "categories", "pages", "suggestions"
        function showFixedSection(container, input, section) {
            let fixedList, sectionLabel, sectionNumber, elementClass;
            switch (section) {
                case 'categories':
                    fixedList = fixedCollectionsList; 
                    sectionLabel = Searchanise.GetWidgets().options.LabelAutocompleteCategories;
                    //sectionLabel = 'TRENDING CATEGORIES';
                    elementClass = 'category';
                    sectionNumber = autcompleteSectionsOrder.indexOf('categories');
                    break;
                case 'pages':
                    fixedList = fixedPagesList; 
                    sectionLabel = Searchanise.GetWidgets().options.LabelAutocompletePages;
                    elementClass = 'page';
                    sectionNumber = autcompleteSectionsOrder.indexOf('pages');
                    break;
                case 'suggestions':
                    fixedList = fixedSuggestionsList;
                    sectionLabel = Searchanise.GetWidgets().options.LabelAutocompleteSuggestions;
                    elementClass = 'suggestion';
                    sectionNumber = autcompleteSectionsOrder.indexOf('suggestions');
                    break;
            }

            isInputValue = window.innerWidth < 821 && $('#snize-mobile-search-input').length ? Boolean($('#snize-mobile-search-input').val()) : Boolean($(input).val());

            if (!isInputValue && fixedList && sectionLabel && sectionNumber != -1 && elementClass) { 

                if (!$(`#snize-ac-items-container-${sectionNumber + 1}`, container).length) {
                    $(`#snize-ac-items-container-${sectionNumber}`, container).after(`<ul class="snize-ac-results-list" id="snize-ac-items-container-${sectionNumber + 1}"></ul>`);
                } else {
                    $(`#snize-ac-items-container-${sectionNumber + 1}`, container).removeClass('snize-hidden');
                }

                if (!$('#snize-custom-message', container).length) {
                    const resultsColumns = $('.snize-ac-results-columns', container).first();

                    if (resultsColumns.length) {
                        resultsColumns.before(`
                            <div id="snize-custom-message" class="snize-custom-message">
                                Start typing to see matching results in the dropdown.
                            </div>
                        `);
                    }
                }

                $(`#snize-ac-items-container-${sectionNumber + 1}`, container).empty();

                $(`#snize-ac-items-container-${sectionNumber + 1}`, container).append(`<li id="snize-${section}-label" class="snize-label" aria-hidden="true">${sectionLabel}</li>`);
                let fixedListEntries = Object.entries(fixedList);
                fixedListEntries.forEach(function(item, index) {
                    $(`#snize-ac-items-container-${sectionNumber + 1}`, container).append(`<li class="snize-${elementClass}" role="button" style="cursor: pointer;" id="snize-${elementClass}-${index}"></li>`);
                    if (section != 'suggestions') {
                        $(`#snize-${elementClass}-${index}`).append(`<a class="snize-view-link" data-no-instant="true" href="${item[1]}">${item[0]}</a>`);
                    } else {
                        $(`#snize-${elementClass}-${index}`).text(item[1]);
                    }
                })

                if (section == 'suggestions') {
                    redirectSuggestions(input);
                }
            }
        }
        
        function redirectSuggestions(input) {
            $('.snize-suggestion').off('click').on('click', function(e) {
                let query = $(this).prop('textContent');
                $(input).val(query);
                $(input).data('autocompleter').select.submitSearchForm();
            })
        }

        function fixHover() {
            let colorPart = Searchanise.GetWidgets().options.ColorsCSS.split('.snize-ac-over-nodrop')[1];
            let hoverColor = colorPart && colorPart.match(/(?<=#)\D+(?=;)/) && colorPart.match(/(?<=#)\D+(?=;)/)[0] ? '#' + colorPart.match(/(?<=#)\D+(?=;)/)[0] : '#EEEEEE'
            $('body').append(
                `<style>
                    .snize-ac-results .snize-category:hover, 
                    .snize-ac-results .snize-page:hover,
                    .snize-ac-results .snize-suggestion:hover {
                        background: ${hoverColor};
                    }
                </style>`
            );
        }
        fixHover();
        
        $(document).on("Searchanise.AutocompleteUpdated", function(event, input, container) {
            showFixedProducts(container, input);
            showFixedSection(container, input, 'categories');
            if (input.val() === '') {
                $('#snize-ac-items-container-1').hide();
            } else {
                $('#snize-ac-items-container-1').show();
            }
        });
    })(window.Searchanise.$);
});